module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Toast"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toastShow),
      expression: "toastShow"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toastShow),
      expression: "toastShow"
    }],
    staticClass: "content",
    class: {
      'top': _vm.position == 'top'
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/image_error@3x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e0d1d70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Toast.vue
// module id = 268
// module chunks = 18